<template>
  <div class="ccui-home-index">
    <div class="navFont"><div>首页>按计划询价</div></div>
    <div class="emc-container">
      <div class="emc-search">
        <div style="width: 900px;">
          <div>
            <span>采购主体：</span>
            <el-select
              v-model="purchaseUintId"
              @change="changeUnit"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in unitName"
                :key="item.orgId"
                :label="item.orgName"
                :value="item.orgId"
                style="width: 315px;"
              />
            </el-select>
          </div>
          <div>
            <span>采购计划：</span>
            <el-select
              v-model="getPlan"
              filterable
              placeholder="请选择"
              remote
              :remote-method="searchFn"
            >
              <el-option
                v-for="item in plans"
                :key="item.planId"
                :label="item.planName"
                :value="item.planId"
            /></el-select>
          </div>
        </div>
        <a href="javascript:;" class="emc-all-submit-order" @click="changePlan"
          >搜索</a
        >
      </div>
      <div v-if="shops.length > 0">
        <div class="emc-header">
          <ul>
            <li><span>采购计划商品</span></li>
            <li><span>计划总数量</span></li>
            <li><span>可采数量</span></li>
          </ul>
        </div>
        <div v-for="(item, index) in shops" :key="index">
          <div class="emc-header1" @click="changeHeaderClick(index)">
            <ul>
              <li>
                <span>设备物资编码：{{ item.matCode }}</span>
              </li>
              <li>
                <span>设备物资名称：{{ item.matName }}</span>
              </li>
              <li>
                <span>{{ item.convNum }}</span>
              </li>
              <li>
                <span>{{ item.availNum }}</span>
              </li>
              <li v-if="item.matSpuInfoBOList.length > 1">
                <span>含更多商城商品</span
                ><img
                  style="margin-left: 2px;"
                  :src="item.isClick ? yunzushangImg : yunzuxiaImg"
                />
              </li>
            </ul>
          </div>
          <div class="emc-content1" v-if="item.matSpuInfoBOList.length == 0">
            <span
              >该设备物资在商城未找到对应商品，可联系专区运营完善商城商品数据</span
            >
          </div>
          <div
            class="emc-content slide-down"
            v-show="
              item.matSpuInfoBOList.length == 1 ||
                (item.isClick == true && item.matSpuInfoBOList.length != 0)
            "
            v-for="(item1, index1) in item.matSpuInfoBOList"
            :key="index1"
            :style="{ borderColor: item1.isClick ? '#0089EF' : '#f1f1f1' }"
          >
            <div>
              <img
                :src="item1.skuPicUrl"
                style="width: 80px;height: 80px;"
                @click="goToDetail(item1)"
              />
            </div>
            <div>
              <ul class="emc-contentText">
                <li>
                  <span>{{ item1.type }}</span
                  ><span @click="goToDetail(item1)" :title="item1.spuName">{{
                    item1.spuName
                  }}</span>
                </li>
                <li>
                  <span>最低价：</span><span>{{ item1.showMinPrice }}</span>
                </li>
                <li>计量单位：{{ item1.spuUnitName }}</li>
              </ul>
            </div>
            <div
              @click="changeClick(index, index1)"
              :class="[item.availNum == 0 ? 'classBlack' : 'classBlue']"
            >
              {{ item1.isClick == true ? "取消" : "选择" }}
            </div>
            <!-- <div style="margin-top: 97px;" v-if="item1.isClick">
              <img src="@/assets/images/yunzudianji.png" />
            </div> -->
          </div>
        </div>
      </div>
      <div
        v-else
        style="height: 200px;
              text-align: center;
              margin: 100px auto;font-family: PingFangSC, PingFang SC;font-weight: 400;"
      >
        暂无数据，请点击搜索！
      </div>
      <div class="inquireButton" v-if="shops.length > 0" @click="inquireFn">
        <span>立即询价</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@/api/login";
import { addUrlPerFix } from "@/utils";
import yunzuxiaImg from "@/assets/images/yunzuxia.png";
import yunzushangImg from "@/assets/images/yunzushang.png";
import {
  queryPurchasePlanList,
  queryPlanMatSpuPage,
  checkAvailNumByPlanId,
  savePlanMatSkuTmp
} from "@/api/plan";
//const VUE_APP_EMI_DETAIL = addUrlPerFix(process.env.VUE_APP_EMI_URL);
const inquiryPriceUrl =
  addUrlPerFix(process.env.VUE_APP_EMPO_URL) + "/inquiryPlanList";
export default {
  name: "plansRent",
  data() {
    return {
      yunzuxiaImg,
      yunzushangImg,
      purchaseUintId: "",
      getPlan: "",
      getPlanCode: "",
      getPlanName: "",
      plans: [],
      unitName: [],
      shops: [],
      psId: "",
      shops1: [
        {
          code: "9213213",
          name: "振荡压路机 ≤6t ≤18kN ≤0.5mm",
          allNums: 20,
          getNum: 20,
          isClick: false,
          matSpuInfoBOList: []
        },
        {
          code: "9213213",
          name: "振荡压路机 ≤6t ≤18kN ≤0.5mm",
          allNums: 20,
          getNum: 20,
          isClick: false,
          matSpuInfoBOList: [
            {
              type: "设备",
              name: "厂家工程水利HZS75混凝土搅拌站、搅拌",
              price: "¥50.00 元/小时",
              unit: "台",
              isClick: false
            },
            {
              type: "设备",
              name: "厂家工程水利HZS75混凝土搅拌站、搅拌",
              price: "¥50.00 元/小时",
              unit: "台",
              isClick: false
            }
          ]
        }
      ]
    };
  },
  methods: {
    searchFn(query) {
      if (query !== "") {
        this.changeUnit(query, 1); // 调用函数获取数据
      } else {
        this.changeUnit(query, 0); // 调用函数获取数据
      }
    },
    goToDetail(item) {
      console.log("1");
      //window.open(`${VUE_APP_EMI_DETAIL}${item.skuId}?orgId=${this.psId}`);
    },
    inquireFn() {
      let params = {
          planId: this.getPlan,
          planMatNumList: []
        },
        params2 = { planSeekSkuTmpBOList: [], planDetailMatTmpBOList: [] };
      let planDetail = this.plans.filter(i => i.planId == this.getPlan);
      this.shops.forEach(item => {
        let flag = false;
        let obj = {};
        item.matSpuInfoBOList.forEach(item2 => {
          if (item2.isClick == true) {
            flag = true;
            obj.planId = planDetail[0].planId;
            obj.planCode = planDetail[0].planCode;
            obj.planName = planDetail[0].planName;
            obj.planMatDetailId = item.planMatDetailId;
            obj.matCode = item.matCode;
            obj.matName = item.matName;
            obj.availNum = item.availNum;
            obj.planClass = planDetail[0].planClass;
            obj = { ...obj, ...item2 };
            delete obj.isClick;
          }
        });
        if (flag) {
          obj.convCompleteNum = item.convCompleteNum;
          obj.convNum = item.convNum;
          params.planMatNumList.push({
            planMatDetailId: item.planMatDetailId,
            availNum: item.availNum
          });
          params2.planDetailMatTmpBOList.push({
            address: item.address,
            leaseCount: item.leaseCount,
            matCode: item.matCode,
            planMatDetailId: item.planMatDetailId,
            measureUnitName: item.measureUnitName,
            measureUnitCode: item.measureUnitCode,
            matName: item.matName
          });
          params2.planSeekSkuTmpBOList.push(obj);
          params2.planId = this.getPlan;
        }
      });
      checkAvailNumByPlanId(params).then(async res => {
        if (res.data.data.changedList.length == 0) {
          let data = (await savePlanMatSkuTmp(params2)).data.data;
          let planId = this.getPlan || data.planId;
          let tmpId = data.tmpId;
          let href =
            this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
            "?CLIENT_ID=100110&CALLBACK_URL=" +
            encodeURIComponent(
              inquiryPriceUrl +
                "?sourceSystem=3&TempCode=" +
                tmpId +
                `&orgId=${this.psId}` +
                `&planId=${planId}`
            );
          window.open(href, "_blank");
        } else {
          this.$message({
            message: "商品数量大于采购计划剩余可采购数量，请刷新后重新选择!",
            type: "error",
            ccuiCustom: true,
            showClose: true
          });
        }
      });
    },
    changePlan() {
      if (!this.psId) {
        this.$message({
          message: "请选择采购主体！",
          type: "error",
          ccuiCustom: true,
          showClose: true
        });
        return;
      }
      if (!this.getPlan) {
        this.$message({
          message: "请选择采购计划！",
          type: "error",
          ccuiCustom: true,
          showClose: true
        });
        return;
      }
      queryPlanMatSpuPage({
        planId: this.getPlan,
        pageNo: -1,
        doUnitId: this.psId,
        sourceSystem: 2,
        isShowPageLoading: true
      }).then(res => {
        res.data.data.rows.forEach(item => {
          item.isClick = false;
          item.matSpuInfoBOList.forEach(item2 => {
            item2.salePrice = 0;
            item2.type =
              item2.firstCaterycode == "61" || item2.firstCaterycode == "62"
                ? "设备"
                : "周材";
            item2.isClick = false;
          });
        });
        if (res.data.data.rows) {
          this.shops = res.data.data.rows.filter(i => i.availNum != 0);
        }
      });
    },
    changeClick(index, index1) {
      if (this.shops[index].availNum == 0) return;
      //this.shops[index].isClick = !this.shops[index].isClick
      this.$set(
        this.shops[index].matSpuInfoBOList[index1],
        "isClick",
        !this.shops[index].matSpuInfoBOList[index1].isClick
      );
    },
    changeHeaderClick(index) {
      console.log("哈哈哈", this.shops[index].isClick);
      this.shops[index].isClick = !this.shops[index].isClick;
    },
    changeUnit(name, type) {
      this.getPlan = "";
      let psId = "";
      if (this.purchaseUintId != "") {
        psId = this.unitName.filter(i => i.orgId == this.purchaseUintId)[0]
          .orgId;
      } else {
        return;
      }
      this.psId = psId;
      let params = {
        opUnitId: psId,
        pageNo: 1,
        pageSize: 10,
        queryTab: 3,
        purchaseCategory: "1",
        baseAppId: 107407,
        isPlanSeekQuery: "1"
      };
      if (type == 1) params.planName = name;
      else if (type == 0) delete params.planName;
      queryPurchasePlanList(params).then(res => {
        this.plans = res.data.data.rows;
      });
    }
  },
  async created() {
    const res = (await getUserInfo({ isShowPageLoading: true })).data.data
      .umOrganizations;
    this.unitName = res;
    this.getPlan = "";
    this.psId = "";
  }
};
</script>
<style lang="scss" scoped>
.navFont {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  margin: 15px auto;
  width: 1150px;
  cursor: pointer;
}
@media screen and (max-width: 1280px) {
  .navFont {
    width: 1063px;
  }
}
/deep/ .el-select-dropdown__item {
  .selected {
    color: #0089ef !important;
  }
}
/* 覆盖el-select下拉菜单项的文字颜色 */
.el-select-dropdown__item {
  color: #333; /* 例如，将文字颜色改为深灰色 */
}
.emc-search {
  display: flex;
  justify-content: space-between;
  .el-select {
    width: 320px;
  }
  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #0089ef !important;
  }
  /deep/ .el-select .el-input__inner:focus {
    border-color: #0089ef !important;
  }

  div {
    display: flex;
    justify-content: space-between;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
      line-height: 16px;
      text-align: right;
      font-style: normal;
      display: inline-block;
      margin: 7px auto;
    }

    .el-input {
      width: 320px;
      height: 30px;
    }
  }

  .emc-all-submit-order {
    /* margin: 23px 18px 0 14px; */
    display: block;
    float: right;
    width: 86px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: #0089ef;
    border-radius: 5px;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
  }
}

.emc-header {
  /* width: 1120px; */
  height: 40px;
  background: #eeeeee;
  margin-top: 20px;

  ul {
    margin: auto 10px;
    display: flex;

    li:first-child {
      width: 660px;
      height: 40px;
    }

    li:nth-child(2) {
      width: 160px;
      height: 40px;
    }

    li:nth-child(3) {
      width: 160px;
      height: 40px;
    }

    span:nth-child(1) {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      margin: 11px auto;
      display: inline-block;
    }
  }
}

.emc-header1 {
  /* width: 1120px; */
  height: 40px;
  background: #ebf2f9;
  margin-top: 10px;
  cursor: pointer;
  ul {
    margin: auto 10px;
    display: flex;

    li:first-child {
      width: 200px;
    }

    li:nth-child(2) {
      width: 460px;
    }

    li:nth-child(3) {
      width: 160px;
    }

    li:nth-child(4) {
      width: 160px;
    }

    li {
      height: 40px;
    }

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      margin: 11px auto;
      display: inline-block;
    }
  }
}
.emc-content1 {
  cursor: pointer;
  /* width: 1120px; */
  height: 60px;
  background: #fbfcff;
  border: 1px solid #f1f1f1;
  span {
    height: 60px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ff142f;
    line-height: 60px;
    text-align: left;
    font-style: normal;
    margin-left: 10px;
  }
}
.emc-content {
  cursor: pointer;
  /* width: 1120px; */
  height: 120px;
  background: #fbfcff;
  border: 1px solid #f1f1f1;
  display: flex;

  div:nth-child(1) {
    width: 80px;
    height: 80px;
    border: 1px solid #f1f1f1;
    margin: auto 10px;
  }

  div:nth-child(2) {
    height: 80px;
    margin: auto 10px;
    width: 1000px;
  }
  .classBlack {
    color: white;
    font-size: 15px;

    width: 70px;
    height: 26px;
    text-align: center;
    border: 1px solid gray;
    background-color: gray;
    border-radius: 5px;
    margin-top: 84px;
  }
  .classBlue {
    width: 70px;
    height: 26px;
    text-align: center;
    border: 1px solid #0089ef;
    margin-top: 84px;
    background: #0089ef;
    border-radius: 5px;
    color: white;
    font-size: 15px;
  }
  // div:nth-child(3) {
  //   width: 70px;
  //   height: 26px;
  //   text-align: center;
  //   border: 1px solid #0089ef;
  //   margin-top: 84px;
  //   }
  .emc-contentText {
    li {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    li:nth-child(1) {
      span:nth-child(1) {
        display: inline-block;
        width: 32px;
        height: 16px;
        background: #7066ff;
        border-radius: 2px;
        color: white;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-align: center;
      }

      span:nth-child(2) {
        width: 312px;
        height: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #4a4a4a;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        margin-left: 10px;
      }
    }

    li:nth-child(2) {
      margin-top: 10px;

      span:nth-child(1) {
        width: 48px;
        height: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #4a4a4a;
        line-height: 16px;
        text-align: left;
        font-style: normal;
      }

      span:nth-child(2) {
        width: 114px;
        height: 22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #ff142f;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-left: 10px;
      }
    }

    li:nth-child(3) {
      width: 72px;
      height: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      margin-top: 10px;
    }
  }
  .slide-down {
    transform: translateY(-100%);
    opacity: 0;
    transition: transform 1s, opacity 1s;
  }

  .slide-down.active {
    transform: translateY(0);
    opacity: 1;
  }
}
.inquireButton {
  width: 200px;
  height: 40px;
  background: #0089ef;
  border-radius: 2px;
  margin-left: 920px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  span {
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    font-style: normal;
  }
}
</style>
